const FAQ_ITEMS = [
  {
    q: "How do I master my career?",
    a: "Many people do not realize how important it is to properly manage the brand that is you. Your future career goals, income level, benefits, and many other factors depend on how well you market yourself.",
  },
  {
    q: "How can CareerMaster help me with marketing myself?",
    a: "Start with a well formatted, relevant, accurate, and validated resume/CV. Upload an existing resume and we help structure the data. Career coaches can then help you surface strengths that often get left off a resume.",
  },
  {
    q: "But I don't like searching for jobs!",
    a: "With CareerMaster you don't search for a job. Matching works for you when you are ready to consider new opportunities — including traditional roles and soft-job engagements.",
  },
  {
    q: "But I don't want a new job right now.",
    a: "That is fine. Build your profile so you are ready when the time comes, and keep interest off until you want to hear about fits.",
  },
  {
    q: "But I don't want to be harassed with jobs that I don't want!",
    a: "You are in control. You set whether you are interested in new opportunities. Once you find a role, turn off notifications.",
  },
  {
    q: "What are soft jobs?",
    a: "Soft jobs are plain-language engagements for discovery and modernization — when a company knows the outcome they need but not every technical detail. CareerMaster matches people who navigate ambiguity and prove results, alongside traditional FTE and contractor placement.",
  },
  {
    q: "Do employers browse candidates?",
    a: "No. Hiring teams post roles or soft jobs and review ranked matches the system surfaces. There is no open candidate search as the primary experience.",
  },
];

export default function Faq() {
  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>Frequently Asked Questions</h1>
      </header>
      <ol className="mkt-faq round">
        {FAQ_ITEMS.map((item) => (
          <li key={item.q}>
            <div className="qanda">
              <div className="q">{item.q}</div>
              <div className="a">{item.a}</div>
            </div>
          </li>
        ))}
      </ol>
    </article>
  );
}
